
import { Component, Vue } from 'vue-property-decorator'
import { ArtistProjectData, artistProjectData } from '../data/artist-data'
import ScrollHintArrows from '../components/ScrollHintArrowsVert.vue'
import isMobile from 'is-mobile'

@Component({
  components: { ScrollHintArrows }
})
export default class About extends Vue {

  private artistsWrapper: HTMLElement | null = null
  private artists: Array<ArtistProjectData> = artistProjectData
  private isMobileDevice = isMobile()
  private imgLoaded: boolean[] = []

  // ************************
  private scrollActive = true
  // ************************

  private fallback =
    'data:image/svg+xml;charset=utf8,<svg xmlns="http://www.w3.org/2000/svg" width="800" height="500"><rect width="100%" height="100%" fill="%23222222"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-family="sans-serif" font-size="16">No image</text></svg>'

  created() {
    this.imgLoaded = new Array(this.artists.length).fill(false)
  }

  mounted() {
    this.artistsWrapper = this.$refs.artistsWrapper as HTMLElement
  }

  imageLoaded(index: number) {
    setTimeout(() => {
      this.$set(this.imgLoaded, index, true)
    }, 200)
  }

  private artistClicked(a: ArtistProjectData): void {
    if (a.externalLink) {
      window.open(a.externalLink, '_blank')
    }
  }
}
